export default "__VITE_ASSET__jIrAq2s5__"